export const FORBIDDEN_CODE = 403
export const UNAUTHORIZED_CODE = 401
export const OK_CODE = 200
export const CREATED_CODE = 201
export const NO_CONTENT_CODE = 204
export const BAD_REQUEST_CODE = 400
export const UNPROCESSABLE_CONTENT_CODE = 422
